import type React from "react"

export const THEME_PREFERENCE_KEY = "theme"

export enum Theme {
  Light = "light",
  Dark = "dark",
}

export interface DigitsTheme {
  mode: Theme
  setMode?: React.Dispatch<Theme>
}

export interface DeprecatedThemeProps {
  themeName?: string
}
